import { _ as _objectWithoutProperties, a as _extends } from '../_rollupPluginBabelHelpers-b0164b33.js';
import React from 'react';
import PropTypes from 'prop-types';
import Bem from '../packages/honey-bem.js';
import { Injecss } from '../packages/injecss.js';
import { c as IconBurger } from '../index-1707f584.js';
import { Icon } from './icon.js';
import { H as HeaderNavigationPropTypes, s as styles } from '../header-navigation-proptypes-340eaeea.js';
export { H as HeaderNavigationPropTypes } from '../header-navigation-proptypes-340eaeea.js';

var bemNav = Bem('header-nav', styles);
var bemSubNav = Bem('header-subnav', styles);
var HeaderNavigation = function HeaderNavigation(_ref) {
  var navigation = _ref.navigation,
      extraClasses = _ref.extraClasses;
  var items = navigation.length && navigation.map(function (_ref2) {
    var content = _ref2.content,
        href = _ref2.href,
        current = _ref2.current,
        RouterLink = _ref2.RouterLink,
        children = _ref2.children,
        key = _ref2.key,
        rest = _objectWithoutProperties(_ref2, ["content", "href", "current", "RouterLink", "children", "key"]);

    return (
      /* eslint-disable no-shadow */
      // I know what I'm doing
      React.createElement("li", {
        className: children ? bemNav.e('item', 'has-subnav') : bemNav.e('item'),
        key: key || content
      }, !children && (RouterLink ? React.createElement(RouterLink, _extends({
        to: href,
        className: bemNav.e('link'),
        activeClassName: bemNav.e('link', {
          active: true
        })
      }, rest), content) : React.createElement("a", _extends({
        className: bemNav.e('link', {
          active: current
        }),
        href: href
      }, rest), content)), children && React.createElement("span", _extends({
        className: bemNav.e('link', {
          active: current
        })
      }, rest), content), children && React.createElement("ul", {
        className: bemSubNav.b(false, extraClasses)
      }, children.map(function (_ref3) {
        var content = _ref3.content,
            href = _ref3.href,
            current = _ref3.current,
            key = _ref3.key,
            RouterLink = _ref3.RouterLink,
            res = _objectWithoutProperties(_ref3, ["content", "href", "current", "key", "RouterLink"]);

        return React.createElement("li", {
          className: bemSubNav.e('item'),
          key: key || content
        }, RouterLink ? React.createElement(RouterLink, _extends({
          to: href,
          className: bemSubNav.e('link'),
          activeClassName: bemSubNav.e('link', {
            active: true
          })
        }, res), content) : React.createElement("a", _extends({
          className: bemSubNav.e('link', {
            active: current
          }),
          href: href
        }, res), content));
      })))
    );
  }) || React.createElement("li", null);
  return React.createElement("ul", {
    className: bemNav.b(false, extraClasses)
  }, items);
};
HeaderNavigation.defaultProps = {
  extraClasses: '',
  navigation: []
};
HeaderNavigation.propTypes = {
  /** Injection in className */
  extraClasses: PropTypes.string,

  /** Array used to construct the navigation, has following structure:
   * {
   *    content - defines link text
   *    href - specifies link URL
   *    current - defines if this item is the current active one
   *    RouterLink - pass custom RouterLink if you need support for ReactRouter or similar libraries
   *    children - subnavigation menu items, array with the same structure should be provided
   * }
   */
  navigation: HeaderNavigationPropTypes
};

var bem = Bem('header', styles);
var bemBrand = Bem('header-brand', styles);
var bemToggler = Bem('header-nav-toggle', styles);
var bemNavWrapper = Bem('header-nav-wrapper', styles);
var bemWidget = Bem('header-widgets', styles);
var Header = function Header(_ref) {
  var extraClasses = _ref.extraClasses,
      brand = _ref.brand,
      fixed = _ref.fixed,
      menuVisible = _ref.menuVisible,
      navigation = _ref.navigation,
      toggleMenu = _ref.toggleMenu,
      mobileWidget = _ref.mobileWidget,
      widget = _ref.widget,
      stickyWidget = _ref.stickyWidget;
  return React.createElement("header", {
    className: bem.b({
      unfixed: !fixed
    }, extraClasses)
  }, React.createElement("div", {
    className: bem.e('inner')
  }, navigation.length >= 1 && React.createElement("button", {
    onClick: toggleMenu,
    type: "button",
    className: bemToggler.b()
  }, React.createElement(Icon, {
    InlineIcon: IconBurger
  })), React.createElement("div", {
    className: bemBrand.b({
      square: brand.square
    })
  }, React.createElement("a", {
    className: bemBrand.e('link'),
    href: brand.href
  }, React.createElement("img", {
    className: bemBrand.e('img'),
    src: brand.image,
    alt: brand.alt
  }))), React.createElement("div", {
    className: Bem('header-navbar', styles).b()
  }, navigation.length >= 1 && React.createElement("div", {
    className: menuVisible ? bemNavWrapper.b('visible') : bemNavWrapper.b()
  }, navigation.length > 0 && React.createElement(HeaderNavigation, {
    navigation: navigation
  }), widget && !stickyWidget && React.createElement("div", {
    className: bemWidget.b('mobile')
  }, widget), mobileWidget && React.createElement("div", {
    className: bemWidget.b('mobile')
  }, mobileWidget))), widget && React.createElement("div", {
    className: stickyWidget ? bemWidget.b('sticky') : bemWidget.b()
  }, widget)));
};
Header.displayName = 'Header';
Header.defaultProps = {
  extraClasses: '',
  navigation: [],
  toggleMenu: function toggleMenu() {},
  menuVisible: false,
  mobileWidget: false,
  widget: false,
  fixed: true,
  stickyWidget: false
};
Header.propTypes = {
  /** Properties for the brand logo:
   * image - URL of your brand image,
   * alt - respective alt for provided image,
   * href - href for the logo link,
   * square - defines if the logo needs to have square sized styles */
  brand: PropTypes.shape({
    image: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
    href: PropTypes.string.isRequired,
    square: PropTypes.bool
  }).isRequired,

  /** Injection in className */
  extraClasses: PropTypes.string,

  /** Array used to construct the navigation, has following structure:
   * `content` - defines link text,
   * `children` - sub navigation menu items (array with the same structure should be provided),
   * `current` - defines if this item is the current active one,
   * `component` - pass custom component if you need support for ReactRouter or similar libraries,
   */
  navigation: HeaderNavigationPropTypes,

  /** Click handler for burger menu (show/hide on mobile) */
  toggleMenu: PropTypes.func,

  /** Controls visibility of the menu */
  menuVisible: PropTypes.bool,

  /** Widget for the header,
   * this gets duplicated into mobile side nav as well by default */
  widget: PropTypes.node,

  /** Widget for the mobile side navigation,
   * use that if you want something to be present in side nav only */
  mobileWidget: PropTypes.node,

  /** Disable widget collapsing into mobile menu */
  stickyWidget: PropTypes.bool,

  /** Set the header to be fixed */
  fixed: PropTypes.bool
};
var header = Injecss(Header, styles);

export { header as Header, HeaderNavigation };
